/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { getColor } from '@airasia-phoenix/react-native/utils/utils';
import { StyleSheet } from 'react-native-unistyles';
import { GENDER_RADIO_HORIZONTAL_SPACING } from './types';

const PARENTAL_CONSENT_TEXT_MAX_WIDTH = 296;
const PARENTAL_CONSENT_LINE_HEIGHT = 18;

const styles = StyleSheet.create((pd) => ({
  pageContainer: {
    flex: 1,
    backgroundColor: getColor(pd.sys.colour.bg_primary),
  },
  mainContainer: {
    gap: pd.ref.space.spacing40.px,
    paddingBottom: pd.ref.space.spacing40.px,
    paddingHorizontal: pd.ref.space.spacing40.px,
  },
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: pd.ref.space.spacing20.px,
    marginBottom: pd.ref.space.spacing30.px,
  },
  dividerRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  divider: {
    flex: 1,
    height: 1,
    backgroundColor: getColor(pd.sys.colour.outline_low),
    margin: 10,
  },
  dividerText: {
    marginHorizontal: pd.ref.space.spacing40.px,
    paddingHorizontal: pd.ref.space.spacing40.px,
  },
  socialSignUpRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginVertical: pd.ref.space.spacing20.px,
  },
  socialSignUpItem: {
    alignItems: 'center',
  },
  socialSignUpGap: {
    height: 4,
  },
  centerContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mobileFieldContainer: {
    width: '100%',
  },
  dialogCodeViewStyleProps: {
    flex: 0.4,
  },
  mobileNumberViewStyleProps: {
    flex: 0.6,
  },
  dialingCodeFlexStyle: {
    flex: 0.48,
  },
  mobileNumberFlexStyle: {
    flex: 0.52,
  },
  genderSection: {
    gap: pd.ref.space.spacing20.px,
    marginBottom: pd.ref.space.spacing20.px,
  },
  genderRadioGroup: {
    marginLeft: -GENDER_RADIO_HORIZONTAL_SPACING,
  },
  parentalConsentRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    width: '100%',
    marginTop: pd.ref.space.spacing20.px,
  },

  parentalConsentCheckbox: {
    width: 24,
    height: 24,
    alignSelf: 'flex-start',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflow: 'hidden',
  },

  parentalConsentLabel: {
    flex: 1,
    minWidth: 0,
    maxWidth: PARENTAL_CONSENT_TEXT_MAX_WIDTH,
    marginLeft: pd.ref.space.spacing30.px,
  },
  parentalConsentText: {
    lineHeight: PARENTAL_CONSENT_LINE_HEIGHT,
  },
  continueButton: {
    marginTop: pd.ref.space.spacing20.px,
  },
  loaderOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
}));

export default styles;
